import React from 'react'
import { authClient } from '../../lib/auth-client'
import { Menu } from '@mui/icons-material'
import { useAppState } from '../../lib/app-state'
import { Link } from 'react-router-dom'
import { Button } from '../ui/button'
import { toast } from '../../lib/toast'
import { queryClient } from '../../api/query-client'
import { ShieldAlert } from 'lucide-react'

const Header: React.FC = () => {
    const { data: session } = authClient.useSession()
    const user = session?.user as any
    const isImpersonating = Boolean((session?.session as any)?.impersonatedBy)
    const toggleSidebar = useAppState((state) => state.toggleSidebar)

    const handleStopImpersonating = async () => {
        const { error } = await authClient.admin.stopImpersonating()

        if (error) {
            toast.error(error.message || 'Failed to stop impersonating')
            return
        }

        toast.success('Returned to your admin session')
        queryClient.clear()
        window.location.href = '/dashboard'
    }

    return (
        <>
            {isImpersonating && (
                <div className="fixed top-0 inset-x-0 z-[503] border-b border-amber-300 bg-amber-50">
                    <div className="mx-auto flex h-11 items-center justify-between gap-3 px-3 sm:px-5">
                        <div className="flex items-center gap-2 text-sm text-amber-900">
                            <ShieldAlert className="h-4 w-4" />
                            <span>
                                Currently impersonating {user?.firstName}{' '}
                                {user?.lastName}
                            </span>
                        </div>
                        <Button
                            size="sm"
                            variant="outline"
                            className="border-amber-300 bg-white text-amber-900 hover:bg-amber-100"
                            onClick={handleStopImpersonating}
                        >
                            Stop Impersonating
                        </Button>
                    </div>
                </div>
            )}
            <nav
                className="bg-card fixed w-full border-b border-border"
                style={{
                    zIndex: 502,
                    top: isImpersonating ? '44px' : 0,
                }}
            >
                <div className="mx-auto px-3 sm:px-5">
                    <div className="flex items-center justify-between h-14">
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => toggleSidebar()}
                                className="text-muted-foreground hover:text-foreground focus:outline-none transition-colors duration-150 hover:bg-accent p-2 -ml-2 rounded-md"
                                aria-label="Toggle sidebar"
                            >
                                <Menu style={{ fontSize: 20 }} />
                            </button>
                            <h1 className="text-foreground text-lg font-semibold tracking-tight">
                                Trakkrr
                            </h1>
                        </div>
                        <div className="hidden sm:flex items-center">
                            {user && (
                                <Link
                                    to="/profile"
                                    className="text-muted-foreground hover:text-foreground text-sm transition-colors duration-150"
                                >
                                    {user.firstName} {user.lastName}
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </nav>
        </>
    )
}

export { Header }
